import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IInternalUserTypeDocuments from '../../interfaces/IInternalUserTypeDocuments';
import ITypeDocument from '../../interfaces/ITypeDocument';

export const useUserTypeDocumentsService = () => {
  const request = useRequest<IInternalUserTypeDocuments>();
  const requestTypeDocument = useRequest<ITypeDocument>();
  const path = 'medical-certificate/type-documents';

  const listById = async (id: string): Promise<IInternalUserTypeDocuments> => {
    return await request
      .getOne({ path: `${path}/${id}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listByUserId = async (id: string): Promise<ITypeDocument[]> => {
    return await requestTypeDocument
      .getMany({ path: `${path}/user-acess/${id}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async (resource: IInternalUserTypeDocuments): Promise<IInternalUserTypeDocuments> => {
    return await request
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: string, resource: string[]): Promise<IInternalUserTypeDocuments> => {
    return await request
      .put({
        path: `${path}/user-acess/${id}`,
        sendAuthorization: true,
        body: {
          typeDocumentId: resource,
        },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: string): Promise<void> => {
    return await request
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { listByUserId, listById, create, update, remove };
};
